import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { GlitchText, TypewriterText, Button } from '../common';
import { MatrixCanvas } from '../effects';

export function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <MatrixCanvas className="opacity-30" />

      <div className="relative z-10 text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono text-cyber-cyan mb-4 text-lg">
            {t('hero.greeting')}
          </p>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-cyber mb-6">
            <GlitchText
              text={t('hero.name')}
              className="text-cyber-green animate-glow"
            />
          </h1>

          <div className="h-8 mb-4">
            <p className="font-mono text-xl md:text-2xl text-cyber-text">
              <TypewriterText text={t('hero.title')} speed={80} />
            </p>
          </div>

          <motion.p
            className="font-mono text-cyber-muted mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2, duration: 1 }}
          >
            {t('hero.subtitle')}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.5, duration: 0.5 }}
          >
            <Button href="#projects">
              {t('hero.cta')}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </Button>
          </motion.div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3, duration: 1 }}
        >
          <motion.div
            className="w-6 h-10 border-2 border-cyber-green/50 rounded-full flex justify-center"
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 2 }}
          >
            <motion.div
              className="w-1 h-2 bg-cyber-green rounded-full mt-2"
              animate={{ opacity: [1, 0, 1] }}
              transition={{ repeat: Infinity, duration: 2 }}
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
